import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from, SubscriptionLike, debounceTime, distinctUntilChanged } from 'rxjs';
import { JdData } from 'src/app/common-interfaces-classes/JdData';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { GenAiJdSearchComponent } from 'src/app/gen-ai-jd-search/gen-ai-jd-search.component';
import { JdDataService } from 'src/app/jd-data.service';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';
declare const clevertap;

export type TextExtractResponse = { status: 'success' | 'failure', text: string, message: string }

@Component({
    selector: 'app-jd-description',
    templateUrl: './jd-description.component.html',
    styleUrls: ['./jd-description.component.scss'],
    standalone: false
})
export class JdDescriptionComponent implements OnInit, OnDestroy {

  projectNameInput: UntypedFormControl = new UntypedFormControl(null);
  projectnameSpecialCharError: boolean = false;
  dublicateProjectNameError: boolean = false;
  projectnameRequiredError: boolean = false;
  showFilterComponent: boolean = false;
  changedJD: boolean = false;

  jdInput: UntypedFormControl = new UntypedFormControl(null);
  jdInputError: boolean = false;

  showSubmitJdSpinner: Boolean = false;
  isUploadedFileCorrect = false;
  incorrectFileFormat = false;
  specialCharaterError = false;
  fileSizeLimitExceeded = false;
  jdDataLoading = false;
  textExtractionError = false;
  uploadedFilename: string;
  uploadedFile = null;
  textExtractionErrorMessage: string;

  subscriptionsLike: SubscriptionLike[] = [];


  enterManualEvent: boolean = false;

  parshedJD: any;
  projectNameInputError: any;

  showProjectLoader: Boolean = false;
  cloneprojectnumber: string = '';
  projectDetails: any;
  redirectSource: string | null = null;

  constructor(
    private aiSourcingService: AiSourcingService,
    private searchtoolbox: SearchtoolboxService,
    private modalService: NgbModal,
    private jdDataService: JdDataService,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private localstorageservice: LocalStorageService,
    private locationService: Location,
    private activatedRoute: ActivatedRoute

  ) {


    this.cloneprojectnumber = window.location.pathname?.split('/')[3];
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.redirectSource = params['source'] || '';
    });
    if (this.cloneprojectnumber) {
      this.getProjectDetails();
    };

    const locationSub = this.locationService.subscribe((p: any) => {
      const tab = p.url;
      if (tab === '/ai-sourcing/project-list') {
        this.modalService.dismissAll();
        this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
      };
    })

    this.subscriptionsLike.push(locationSub);

    // this.aiSourcingHandlerService.setDisplayPageEvent('jd-page');
    const storeProjectData = JSON.parse(this.localstorageservice.getItem('parshedJD'));
    if (storeProjectData && !this.cloneprojectnumber?.trim()) {
      this.projectNameInput.setValue(storeProjectData.projectName);
      this.jdInput.setValue(storeProjectData.projectDescription);
      this.redirectSource = storeProjectData.redirectSource || null;
      this.cloneprojectnumber = storeProjectData.cloneprojectnumber || '';
      this.changedJD = true;
    };


    this.aiSourcingHandlerService.getShowFilterComponent.subscribe((res: boolean) => {
      if (res) {
        this.changedJD = false;
        this.showFilterComponent = true;
        setTimeout(() => {
          const filterRow = document.querySelector<HTMLElement>("#filterC");
          if (filterRow) {
            const y = filterRow.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({ top: y, behavior: "smooth" });
          }
        }, 0);
      } else {
        this.showFilterComponent = false;
        this.changedJD = true;
      }
    })

  }

  ngOnInit() {

    /**Check if the redirect source is edit then no need to update projectname */
    if (this.redirectSource === 'edit') {
      this.projectNameInput.disable();
    }

this.projectNameInput.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((value: string) => {
  if (!value) {
    this.projectnameSpecialCharError = false;
    return;
  }
  const normalizedValue = value
    .normalize('NFKD')
    .replace(/[^\x00-\x7F]/g, '');
  if (value !== normalizedValue) {
    this.projectNameInput.setValue(normalizedValue, { emitEvent: false });
  }

  const inputRegex = /^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)"'* ]*$/;

  if (!inputRegex.test(normalizedValue)) {
    this.projectnameSpecialCharError = true;
  } else {
    this.projectnameSpecialCharError = false;
    if (this.redirectSource !== 'edit') {
      this.getDuplicateProjectNameError(normalizedValue);
    }
  }
});


    this.jdInput.valueChanges.subscribe((value) => {
      // this.changedJD = this.cloneprojectnumber ? false : true;
      this.changedJD = true;
      this.aiSourcingHandlerService.setDisplayPageEvent('jd-page');
      this.localstorageservice.clearItem('parshedJD');
      // this.aiSourcingHandlerService.setEnterManualEvent(true);
    });

    setTimeout(() => {
      if (this.cloneprojectnumber) {
        // this.changedJD = this.cloneprojectnumber ? false : true;
        this.changedJD = false;
      }
    }, 1000)

  }

  ngOnDestroy(): void {
    // this.modalService.dismissAll();
    // this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
  };

  /**
   * Method to redirect on blog page
   */
  learnMoreDetails() {
    window.open('https://fire-crib-a04.notion.site/Learn-how-to-use-AI-Sourcing-most-effectively-264d71872fa5806aa880c8ae3481d95f');
  };

  /**
   * Method to check if the project name already exists.
   * @param projectName
   */
  getDuplicateProjectNameError(projectName: string) {

    this.aiSourcingService.isDuplicateProjectName(projectName).subscribe((response: any) => {
      if (response && response.status == 'success') {
        if (response && response.duplicate) {
          this.dublicateProjectNameError = true;
        } else {
          this.dublicateProjectNameError = false;
        }
      } else {
        this.dublicateProjectNameError = false;
      }
    })
  };


  /**
  * Method to submit the job description.
  */
  submitJD() {

    if (!this.jdInput.value?.trim()) return;
    if(!this.projectNameInput.value?.trim()) {
      this.projectnameRequiredError = true;
      return
    }
    this.showFilterComponent = true;
    this.changedJD = false;

    if (this.showFilterComponent) {
      window.scrollTo(0, 500);
    }

    const modalRef = this.modalService.open(
      GenAiJdSearchComponent,
      { windowClass: 'genAimodal', centered: true, backdrop: 'static', keyboard: false }
    );
    const modalInstance: GenAiJdSearchComponent = modalRef.componentInstance;
    modalInstance.description = this.jdInput.value;
    modalInstance.calledFrom = 'ai-sourcing';

    const modalResult$ = from(modalRef.result);

    modalResult$.subscribe((response: JdData) => {
      if (response && response.status == 'success') {
        setTimeout(() => {
          const filterRow = document.querySelector<HTMLElement>("#filterC");
          if (filterRow) {
            const y = filterRow.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({ top: y, behavior: "smooth" });
          }
        }, 0);
        this.parshedJD = response.jdData;
        this.aiSourcingHandlerService.setDisplayPageEvent('search-criteria');
        const storeProjectData = {
          projectName: this.projectNameInput.value,
          projectDescription: this.jdInput.value,
          parshedJD: response,
          redirectSource: this.redirectSource
        };
        this.localstorageservice.setItem('parshedJD', JSON.stringify(storeProjectData));
        const editProjectDetails = {
          redirectSource: this.redirectSource ? this.redirectSource : null,
          cloneprojectnumber: this.cloneprojectnumber ? this.cloneprojectnumber : ''
        };
        this.jdDataService.emitJDDataEvent({...response, editProjectDetails: editProjectDetails});
      } else {
        this.resetFormFields();
        this.jdInput.setValue(null);
        this.showFilterComponent = false;
      }
        /**
     * Submit JD
     */
         const submitJDParams = {
          "User ID": this.localstorageservice.getItem('userdata').userid,
          "Project Name": this.projectNameInput.value
        }
        clevertap.event.push("Autopilot-Submit JD",submitJDParams);
    });
  };

  /**
   * Method to upload a file.
   * @param event
   */
  uploadFile(event: any) {

    this.showFilterComponent = false;
    this.resetFormFields();
    const oldFile = event.target.files[0];
    this.uploadedFile = GlobalService.validateAndSanitizeFile(oldFile);
    this.validateInputFile();
    this.aiSourcingHandlerService.setEnterManualEvent(true);

    if (this.uploadedFile && !this.specialCharaterError && !this.incorrectFileFormat && !this.fileSizeLimitExceeded) {
      this.isUploadedFileCorrect = true;
      this.uploadedFilename = oldFile.name;
      this.jdDataLoading = true;

      this.searchtoolbox.documentToText(this.uploadedFile).subscribe((response: TextExtractResponse) => {
        this.jdDataLoading = false;
        this.processTextractResponse(response);
      }, () => this.jdDataLoading = false);
    }
  };

  /**
   * Method to set extracted text to the job description input.
   * @param response
   */
  private processTextractResponse(response: TextExtractResponse) {
    if (response.status === "success") {
      this.jdInput.setValue(response.text);
      this.textExtractionError = false;
      this.textExtractionErrorMessage = null;
    }
    else if (response.status === "failure") {
      this.textExtractionError = true;
      this.textExtractionError = true;
      this.textExtractionErrorMessage = response.message;
    }
  }

  /**
   * Method to validate the uploaded file.
   */
  private validateInputFile() {
    const validFileExtensions = ['doc', 'docx', 'pdf', 'txt', 'odt'];
    const uploadedFileExtension = this.uploadedFile?.name?.split('.')[1];

    if (!validFileExtensions.includes(uploadedFileExtension.toLowerCase())) {
      this.incorrectFileFormat = true;
    }

    // Verify file size (File size cannot exceed 5 MB)
    if (this.uploadedFile.size > 5242880) {
      this.fileSizeLimitExceeded = true;
    }
  }

  /**
   * Method to reset form fields.
   */
  resetFormFields() {
    this.aiSourcingHandlerService.setEnterManualEvent(true);
    this.incorrectFileFormat = false;
    this.specialCharaterError = false;
    this.isUploadedFileCorrect = false;
    this.uploadedFilename = null;
    this.fileSizeLimitExceeded = false;
    this.jdInput.setValue(null);
  }

  /**
   * Method to enter job description manually.
   */
  enterManually() {
    this.aiSourcingHandlerService.setEnterManualEvent(true);
    this.resetFormFields();
    this.showFilterComponent = true;
    this.projectNameInput.setValue(null);
    this.jdInput.setValue(null);
  };


  getProjectDetails() {
    this.showProjectLoader = true;
    this.aiSourcingService.getProjectDetails(this.cloneprojectnumber).subscribe((res: any) => {
      this.showProjectLoader = false;
      if (res && res.status == 'success') {
        this.showFilterComponent = true;
        this.changedJD = false;

        this.projectDetails = res.data;
        this.projectDetails.projectname = `${this.projectDetails.projectname} ${this.redirectSource == 'edit' ? '' : '- copy'}`;
        this.projectDetails.parsedjobdescription = JSON.parse(this.projectDetails.parsedjobdescription);

        this.projectNameInput.setValue(this.projectDetails.projectname);
        this.jdInput.setValue(this.projectDetails.jobdescription);


        this.aiSourcingHandlerService.setDisplayPageEvent('search-criteria');
        const storeProjectData = {
          projectName: this.projectNameInput.value,
          projectDescription: this.jdInput.value,
          parshedJD: this.projectDetails.parsedjobdescription,
          filterApplied: this.projectDetails,
          cloneprojectnumber: this.cloneprojectnumber,
          redirectSource: this.redirectSource
        };
        this.localstorageservice.setItem('parshedJD', JSON.stringify(storeProjectData));
      } else {
        this.projectDetails = {};
        this.showFilterComponent = false;
      }
    })
  };


}
